import { render, staticRenderFns } from "./introheader.vue?vue&type=template&id=b9a7c232"
import script from "./introheader.vue?vue&type=script&lang=js"
export * from "./introheader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports